import orange from '@material-ui/core/colors/orange';
import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Title: {
    color: '#424242',
    borderBottom: '1px solid grey',
    backgroundColor: '#f1f1f1',
    padding: '5px',
    fontSize: '20px',
    marginBottom: '20px',
  },
  Container: {
    marginLeft: '25px',
  },
  Field: {
    display: 'grid',
    padding: '10px',
  },
  Bold: {
    fontWeight: 'bold',
  },
  UpperCase: {
    textTransform: 'uppercase',
  },
  MarginTop: {
    marginTop: '20px',
  },
  MarginBottom: {
    marginBottom: '20px',
  },
  MarginsAll: {
    margin: '10px',
  },
  SaveAllButton: {
    margin: '10px',
  },
  CustomFieldButton: {
    marginBottom: '7px',
  },
  StickyFooter: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    borderTop: '1px solid gray',
  },
  endAdornmentIcon: {
    fontSize: '24px',
  },
  errorIcon: {
    color: orange[400],
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
